import { Controller, type Control, type FieldValues, type Path } from 'react-hook-form';
import { Label, Input, Select } from '@shared/components';
import { TITLE_OPTIONS } from './titleOptions';

interface Props<T extends FieldValues> {
    control: Control<T>;
    /** One field per row, as the address and contact blocks lay out. */
    stacked?: boolean;
}

export function CustomerNameFields<T extends FieldValues>({ control, stacked = false }: Props<T>) {
    return (
        <div className={stacked ? 'space-y-4' : 'grid grid-cols-1 sm:grid-cols-3 gap-4'}>
            <div>
                <Label htmlFor="title">Title *</Label>
                <Controller
                    name={'title' as Path<T>}
                    control={control}
                    render={({ field, fieldState }) => (
                        <Select
                            {...field}
                            id="title"
                            options={TITLE_OPTIONS}
                            placeholder="Please select a Title"
                            value={field.value}
                            error={!!fieldState.error}
                            hint={fieldState.error?.message}
                        />
                    )}
                />
            </div>
            <div>
                <Label htmlFor="forename">Forename *</Label>
                <Controller
                    name={'forename' as Path<T>}
                    control={control}
                    render={({ field, fieldState }) => (
                        <Input
                            id="forename"
                            type="text"
                            {...field}
                            error={!!fieldState.error}
                            hint={fieldState.error?.message}
                        />
                    )}
                />
            </div>
            <div>
                <Label htmlFor="surname">Surname *</Label>
                <Controller
                    name={'surname' as Path<T>}
                    control={control}
                    render={({ field, fieldState }) => (
                        <Input
                            id="surname"
                            type="text"
                            {...field}
                            error={!!fieldState.error}
                            hint={fieldState.error?.message}
                        />
                    )}
                />
            </div>
        </div>
    );
}
